import {
  GET_ALL_ADMINS
} from 'src/store/mutation-types'

export default {
  [GET_ALL_ADMINS] (state, administrators) {
    state.administrators = administrators
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/store/mutations.js